import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Basic from '../../Components/Basic/Basic';
import Toast from '../../Components/Toast/Toast';
import Common from '../../services/common.js';
import dayjs from 'dayjs';
import $ from 'jquery';

import './EmailESign.css';

const EmailESign = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // State variables
  const [errors, setErrors] = useState([]);
  const [token, setToken] = useState('');
  const [approval, setApproval] = useState('');
  const [linkCode, setLinkCode] = useState('');
  const [docName, setDocName] = useState('Email E-Signature');
  const [form, setForm] = useState({});
  const [errorFlag, setErrorFlag] = useState(0);
  const [confirm, setConfirm] = useState(0);
  const [confirmError, setConfirmError] = useState('');
  const [approvalDocList, setApprovalDocList] = useState([]);
  const [currentDate, setCurrentDate] = useState(dayjs(new Date()).format("DD/MM/YYYY"));
  const [localStorageData, setLocalStorageData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isApprovalValid, setIsApprovalValid] = useState(false);
  
  const toastRef = useRef();
  const errorBlockRef = useRef();
  const subBtnRef = useRef();

  const STORAGE_KEY = "caprock-local";

  useEffect(() => {
    initializeComponent();
  }, []);

  const initializeComponent = () => {
    const js = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    setLocalStorageData(js);

    const tokenParam = searchParams.get('token');
    const approvalParam = searchParams.get('approval');
    const ltokenParam = searchParams.get('ltoken');

    setToken(tokenParam || '');
    setApproval(approvalParam || '');
    setLinkCode(ltokenParam || '');

    tokenAlert();
    
    if (approval && approval !== '') {
      checkApprovalValid(approval);
    } else {
      checkApprovalValid(0);
    }

    setForm(prev => ({
      ...prev,
      curdate: dayjs(new Date()).format("YYYY-MM-DD")
    }));

    document.title = `${docName} || Caprock Merchant Platform`;
  };

  const checkApprovalValid = (approvalId) => {
    Common.is_approval_valid(approvalId, token)
      .then(response => {
        console.log(response);
        if (response.data && response.data.success === 200) {
          setIsApprovalValid(true);
          
          if (response.data.data.approval_doc_list && response.data.data.approval_doc_list.length > 0) {
            setApprovalDocList(response.data.data.approval_doc_list);
          }

          // Pre-fill form if approval response exists
          if (response.data.master && response.data.master.approval_response) {
            try {
              const apRes = JSON.parse(response.data.master.approval_response);
              if (apRes) {
                setForm(prev => ({
                  ...prev,
                  e_name: apRes.e_name || '',
                  e_email: apRes.e_email || '',
                  e_phone_no: apRes.e_phone_no || '',
                  e_dob: apRes.e_dob || ''
                }));
              }
            } catch (e) {
              console.log('Error parsing approval response:', e);
            }
          }
        } else {
          toastRef.current?.miralToast('Warning', 'Link expired!', '', false);
          setTimeout(() => {
            window.location.href = "https://caprock.com.au";
          }, 2500);
        }
      })
      .catch(e => {
        console.log(e);
        toastRef.current?.miralToast('Error', 'Failed to validate approval link', '', false);
      });
  };

  const tokenAlert = () => {
    if (!token || token === '' || token === 'undefined') {
      alert('This URL is invalid please contact caprock support team');
      window.location.href = 'https://caprock.com.au';
    }
  };

  const submitForm = (e) => {
    e.preventDefault();
    
    if (!isApprovalValid) {
      toastRef.current?.miralToast('Warning', 'Please wait for approval validation', '', false);
      return;
    }

    setIsLoading(true);
    $(subBtnRef.current).attr('disabled', 'disabled');
    $(subBtnRef.current).text('Processing ... ');

    // Validation Check
    setErrors([]);
    setErrorFlag(0);

    const required = [
      { 'key': 'e_name', 'name': 'Your Name' }, 
      { 'key': 'e_email', 'name': 'Email' }, 
      { 'key': 'e_phone_no', 'name': 'Phone No' },
      { 'key': 'e_dob', 'name': 'Date Of Birth' } 
    ];

    const validEmails = [ 
      { 'key': 'e_email', 'name': 'E-Signature Email' }
    ];

    const validPhones = [ 
      { 'key': 'e_phone_no', 'name': 'E-Signature Phone' }
    ];

    // Validate required fields
    for (let i = 0; i < required.length; i++) {
      requiredInput(required[i]['key'], required[i]);
    }

    // Validate emails
    for (let i = 0; i < validEmails.length; i++) {
      validEmail(validEmails[i]['key'], validEmails[i]);
    }

    // Validate phones
    for (let i = 0; i < validPhones.length; i++) {
      checkPhone(validPhones[i]['key']);
    }

    if (confirm === 0) {
      setConfirmError("Please agree to condition.");
      setErrorFlag(1);
    } else {
      setConfirmError("");
    }

    if (errorFlag === 0) {
      let formData = new FormData();
      
      for (const key in form) {
        formData.append(key, form[key]);
      }
      
      formData.append('token', token);  
      formData.append('approval', approval);
      formData.append('curdate', dayjs(new Date()).format("YYYY-MM-DD"));

      const url = Common.base_url() + 'customer-email-esignature';

      fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(response => response.json())
      .then(data => { 
        if (data.success === 200) {    
          toastRef.current?.miralToast('Success', data.message, '', false); 
          setTimeout(() => { 
            navigate('/sign-in'); 
          }, 2500);

          $(subBtnRef.current).removeAttr('disabled');
          $(subBtnRef.current).text('Submit Now'); 
        } else { 
          toastRef.current?.miralToast('Warning', data.message, '', false); 
          $(subBtnRef.current).removeAttr('disabled');
          $(subBtnRef.current).text('Submit Now');
        } 
      })
      .catch(error => {
        toastRef.current?.miralToast('Error', 'Failed to submit form', '', false);
        $(subBtnRef.current).removeAttr('disabled');
        $(subBtnRef.current).text('Submit Now'); 
      });
    } else {
      toastRef.current?.miralToast('Warning', 'Please fill all required fields before submitting.', '', false);
      $(subBtnRef.current).removeAttr('disabled');
      $(subBtnRef.current).text('Submit Now');
    }
    
    setIsLoading(false);
  };

  const checkPhone = (fieldName) => {
    const ph = form[fieldName];
    let valid = 1;
    let errorMsg = 'Please enter valid phone number';

    if (ph && ph.length < 7 || ph && ph.length > 12) {
      valid = 0;
      errorMsg = 'Phone number length is not valid';
    }
    if (ph && isNaN(ph)) {
      valid = 0;
      errorMsg = 'Only number character is allowed';
    }
    if (!ph || ph === '') {
      valid = 0;
      errorMsg = 'Please enter phone number';
    }

    $('.' + fieldName + 'err').html('');
    if (valid === 0) {
      $("#" + fieldName).before('<span class="' + fieldName + 'err errorMsg danger ml-2 float-right">' + errorMsg + '</span>');
      setErrorFlag(1);
    }
  };

  const validEmail = (eId, obj) => {
    const tagName = $("#" + eId).attr("name");
    const eVal = $("#" + eId).val();
    let valid = 1;
    let errorMsg = 'Please enter valid email address';
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (obj && obj !== null) {
      errorMsg = 'Please enter a valid email address for field - ' + obj.name;
    }
    if (!re.test(String(eVal).toLowerCase())) {
      valid = 0;
    }
    $('.' + tagName + 'err').html('');
    if (valid === 0) {
      setErrorFlag(1);
      $("#" + eId).before('<span class="' + tagName + 'err errorMsg danger ml-2 float-right">' + errorMsg + '</span>');
    }
  };

  const requiredInput = (rId, obj) => {
    const tagName = $("#" + rId).attr("name");
    const rVal = $("#" + rId).val();
    let valid = 1;
    let em = 'Field required';

    if (rVal === undefined || rVal === '' || rVal === null) {
      em = tagName + ' is required';
      valid = 0;
    }
    if (obj && obj !== null) {
      em = obj.name + ' is required';
    }

    if (valid === 0) {
      setErrorFlag(1);
      $('.' + tagName + 'err').html('');
      $("#" + rId).before('<span class="' + tagName + 'err errorMsg danger ml-2 float-right">' + em + '</span>');
    }
  };

  const removeTagErr = (event) => {
    const tagName = event.target.name;
    $('.' + tagName + 'err').html('');
  };

  const openModal = (id) => {
    $('#' + id).addClass('d-block');
    $('#' + id).addClass('show');
    $('#' + id).css('overflow-y', 'scroll');
  };

  const closeModal = (id) => {
    $('#' + id).removeClass('d-block');
    $('#' + id).addClass('d-none');
    $('#' + id).removeClass('show'); 
  };

  if (!isApprovalValid) {
    return (
      <>
        <Basic />
        <section className="closefriend-hero background-white">
          <div className="container mt-3">
            <div className="row justify-content-center">
              <div className="col-md-8 text-center">
                <div className="login-card bg-white p-4" style={{ borderRadius: '6px' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p className="mt-3">Validating approval link...</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <Basic />
      <section className="closefriend-hero background-white">
        <div className="container mt-3">
          <form onSubmit={submitForm} className="my-1">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-10 offset-xl-1">
                <div className="row">
                  <div className="col-md-12 col-12 text-center">
                    <p style={{ fontSize: '2rem', fontWeight: 700, letterSpacing: '0.1rem', lineHeight: 'normal' }}>
                      Email E-Signature
                    </p>
                  </div>
                </div>

                <div className="login-card bg-white p-4" style={{ borderRadius: '6px' }}>
                  <div className="login-body">
                    <div className="form-group mt-1 mb-0">
                      <h5>
                        E-Signature
                        <label className="label float-right">Date : {currentDate}</label>
                      </h5>
                      <hr />
                    </div>
                    
                    <div className="row">
                      <div className="form-group col-md-6">
                        <input
                          onChange={(e) => setForm(prev => ({ ...prev, e_name: e.target.value }))}
                          onInput={removeTagErr}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          type="text"
                          placeholder="Your Name"
                          className="form-control selected-field"
                          value={form.e_name || ''}
                          name="e_name"
                          id="e_name"
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          onChange={(e) => setForm(prev => ({ ...prev, e_email: e.target.value }))}
                          onInput={removeTagErr}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          type="email"
                          placeholder="Your Email Address"
                          className="form-control selected-field"
                          value={form.e_email || ''}
                          name="e_email"
                          id="e_email"
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          onChange={(e) => setForm(prev => ({ ...prev, e_phone_no: e.target.value }))}
                          onInput={removeTagErr}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          type="tel"
                          placeholder="Your Phone Number"
                          className="form-control selected-field"
                          value={form.e_phone_no || ''}
                          name="e_phone_no"
                          id="e_phone_no"
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          onChange={(e) => setForm(prev => ({ ...prev, e_dob: e.target.value }))}
                          onFocus={(e) => e.target.setAttribute('autocomplete', 'disable-autocomplete')}
                          autoComplete="off"
                          value={form.e_dob || ''}
                          type="date"
                          placeholder="Your Date of Birth"
                          className="form-control selected-field"
                          name="e_dob"
                          id="e_dob"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group mt-1 mb-0">
                      <input
                        id="icheck"
                        type="checkbox"
                        className="form-control"
                        name="icheck"
                        required
                        checked={confirm === 1}
                        onChange={(e) => setConfirm(e.target.checked ? 1 : 0)}
                      />
                      <span
                        className="p-cursor"
                        onClick={() => {
                          setConfirm(0);
                          setConfirmError('');
                        }}
                        style={{ display: confirm === 1 ? 'inline' : 'none' }}
                      >
                        <svg style={{ height: '15px', width: '15px', margin: '5px' }} width="100mm" height="100mm" version="1.1" viewBox="0 0 100 100">
                          <defs>
                            <clipPath id="a">
                              <path d="m139.21 139.21h473.58v473.58h-473.58z" inkscapeConnectorCurvature="0" />
                            </clipPath>
                          </defs>
                          <g transform="translate(0,-197)" inkscapeGroupmode="layer" inkscapeLabel="Layer 1">
                            <g transform="matrix(1.6371 0 0 1.6371 16.358 -155.86)">
                              <path d="m-8.417 217.52h57.655v57.655h-57.655z" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="1.6707" inkscapeConnectorCurvature="0" />
                              <g transform="matrix(.35278 0 0 .35278 -152.74 113.7)" clipPath="url(#a)">
                                <path transform="matrix(4.7358,0,0,4.7358,139.21,139.21)" d="m64.04 52.74 6.31 6.9806 13.98-20.311" fill="none" stroke="#000" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="5" inkscapeConnectorCurvature="0" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span
                        className="p-cursor"
                        onClick={() => {
                          setConfirm(1);
                          setConfirmError('');
                        }}
                        style={{ display: confirm === 0 ? 'inline' : 'none' }}
                      >
                        <svg style={{ height: '15px', width: '15px', margin: '5px' }} width="100mm" height="100mm" viewBox="0 0 100 100">
                          <defs>
                            <clipPath id="a">
                              <path d="m139.21 139.21h473.58v473.58h-473.58z" inkscapeConnectorCurvature="0" />
                            </clipPath>
                          </defs>
                          <g transform="translate(0,-197)" inkscapeGroupmode="layer" inkscapeLabel="Layer 1">
                            <path d="m2.5789 200.25h94.389v94.389h-94.389z" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="2.7351" inkscapeConnectorCurvature="0" />
                          </g>
                        </svg>
                      </span>
                      <label className="label">
                        I confirm that I have received, agreed and acknowledge the following documents.
                      </label>
                      <ol style={{ fontSize: '13px' }}>
                        {approvalDocList.map((doc, index) => (
                          <li key={index}>{doc}</li>
                        ))}
                      </ol>
                      <small className="errorMsg danger ml-2">{confirmError}</small>
                    </div>
                  </div>
                  
                  <div className="row justify-content-center mx-md-0 mx-1 mb-1 mt-0">
                    <div className="col-md-12 col-12 px-1">
                      <button
                        id="subBtn"
                        type="submit"
                        ref={subBtnRef}
                        disabled={isLoading}
                        className="btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                      >
                        {isLoading ? 'Processing...' : 'Submit E-Signature'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Please fix this</h5>
              <button type="button" onClick={() => closeModal('exampleModal')} className="btn btn-secondary" data-mdb-dismiss="modal">
                Close
              </button>
            </div>
            <div className="modal-body">
              <div ref={errorBlockRef} id="errorBlock">
                {errors.length > 0 && errors.map((error, key) => (
                  <div key={key} className="alert alert-danger">
                    {error}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Toast ref={toastRef} />
    </>
  );
};

export default EmailESign;
